import { IProPlayerInfo, ITag } from "./@types";

export const parseProPlayer = (tags?: ITag[] | null): IProPlayerInfo | null => {
  if (!tags?.length) return null;

  const byKey = new Map<string, string>();
  tags.forEach(({ key, value }) => {
    if (key && value != null && !byKey.has(key)) byKey.set(key, value);
  });

  const get = (key: string) => byKey.get(key) || undefined;

  const playerName = get("PARTNER_playerName") || get("proPlayerName");
  if (!playerName) return null;

  return {
    playerName,
    playerFullName: get("PARTNER_playerFullName"),
    avatar: get("PARTNER_avatar") || get("PARTNER_playerPhoto"),
    countryISO: get("PARTNER_playerCtryISO"),
    teamName: get("PARTNER_teamName"),
    teamLogo: get("PARTNER_teamLogo"),
    teamCountryISO: get("PARTNER_teamCtryISO"),
    opponentTeamName: get("PARTNER_opponentTeamName"),
    opponentTeamLogo: get("PARTNER_opponentTeamLogo"),
    eventName: get("PARTNER_eventName"),
    eventLogo: get("PARTNER_eventLogo"),
    scoreLine: get("PARTNER_scoreLine"),
    seriesGameLabel: get("PARTNER_seriesGameLabel"),
  };
};
